import * as React from 'react';
import classnames from 'classnames';
import styles from './BackLink.module.css';
import { Link } from '@watcherr/ui';
import { useNavigate } from 'react-router-dom';

interface BackLinkProps {
  name?: string;
  fallbackUrl: string;
}

const BackLink: React.FC<BackLinkProps> = ({ name = 'Go back', fallbackUrl }) => {
  const navigate = useNavigate();
  const [canGoBack, setCanGoBack] = React.useState(false);

  React.useEffect(() => {
    // Check if we have navigation state (meaning we navigated within the app)
    setCanGoBack(window.history.state?.idx > 0);
  }, []);

  const inner = (
    <>
      <i className={classnames('icon-arrow-left', styles.Icon)} />
      <span className={styles.Name}>{name}</span>
    </>
  );

  const handleBackLinkClick = React.useCallback(() => {
    if (canGoBack) {
      navigate(-1);
    } else {
      navigate(fallbackUrl);
    }
  }, [navigate, canGoBack, fallbackUrl]);

  return (
    <div className={styles.BackLink}>
      <a className={styles.Link} onClick={handleBackLinkClick}>
        {inner}
      </a>
    </div>
  );
};

export default BackLink;
